// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__OBP1e","clinicsSelect":"TableHeading_clinicsSelect__1N8Za"};